<template>
    <perfect-scrollbar class="result-container position-relative d-block stores-list-container h-100 overflow-scroll" :class="{'bg-secondary-l': storesVisibleCount === 0 }" ref="scroll">
        <ResultSummary></ResultSummary>
        <div id="store-list-container" class="pb-12 pb-lg-0">
            <div v-for="store in markers" :key="store.id" @click="cardClick(store.id)" :ref="refStore(store.id)" class="store store-container border-l-bottom-secondary-l" v-if="store.status === '1'">
                <store :store="store"
                          :class="{'selected': selectedStore && selectedStore.id === store.id}"
                          v-if="store.visible && store.status === '1'"
                          >
                </store>
            </div>
        </div>
    </perfect-scrollbar>
</template>

<script>
import Store from '@/components/Store'
import ResultSummary from '@/components/ResultSummary'
import { mapState, mapGetters } from 'vuex'

export default {
    name: 'storesList',
    components: {
        Store,
        ResultSummary
    },
    props: {
        markers: {
            type: Array,
            required: true
        }
    },
    watch: {
        selectedStore () {
            if (this.selectedStore && this.selectedStore.source) {
                if (this.selectedStore.source === 'map') {
                    let offsetTop = this.$refs['store_' + this.selectedStore.id][0].offsetTop
                    this.$refs.scroll.$el.scrollTop = offsetTop
                }
            }
        }
    },
    computed: {
        ...mapState([
            'selectedStore'
        ]),
        ...mapGetters('store', ['storesVisibleCount'])
    },
    methods: {
        cardClick (id) {
            let marker = this.markers.find(m => m.id === id)
            this.$store.dispatch('setStore', {
                source: 'list',
                store: marker
            })
        },
        refStore (id) {
            return 'store_' + id
        }
    }
}
</script>

<style>

</style>
